// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';

export const createGroupRequested = createAction('[CREATE GROUP] Create Requested', props<{
  clientId: number,
  name: string,
  selections: number[]
}>());
export const createGroupRequestSuccess = createAction('[CREATE GROUP] Create Request Success', props<{
  groupId: string,
  clientId: number,
  name: string
}>());
export const createGroupRequestError = createAction('[CREATE GROUP] Create Request Error', props<{ error: string }>());
